import { connect } from 'react-redux';
import { push } from 'redux-little-router';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { routeMap } from 'router';
import PersonalData from '../components/PersonalData';
import {
  avatarSelector,
  innSelector,
  personalDataIsErrorSelector,
  personalDataIsLoadingSelector,
  personalDataSelector,
  readOnlySelector,
  taxExemptionsSelector,
  userInfoSelector,
} from 'modules/Profile/components/PersonalData/selectors';
import { personalDataPageInit } from 'modules/Profile/components/PersonalData/actions';
import { getAvatar } from 'modules/App/redux/avatar/actions';

const mapStateToProps = createStructuredSelector({
  inn: innSelector,
  personalData: personalDataSelector,
  userInfo: userInfoSelector,
  avatar: avatarSelector,
  isReadOnly: readOnlySelector,
  taxExemptions: taxExemptionsSelector,
  isError: personalDataIsErrorSelector,
  isLoading: personalDataIsLoadingSelector,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      goToChangePersData: () => push(routeMap.updatePersonalData),
      loadAvatar: getAvatar,
      personalDataPageInit,
    },
    dispatch,
  );
export default connect(mapStateToProps, mapDispatchToProps)(PersonalData);
